import React, { useEffect, useRef } from 'react';

const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
const SITEKEY = process.env.REACT_APP_TURNSTILE_SITEKEY || '';

// 挂件自身文案跟随应用界面语言(Turnstile 默认按浏览器语言,会和站点设置不一致)
const LANG_MAP = { en: 'en', ko: 'ko', ja: 'ja', zh: 'zh-CN', vi: 'vi' };
const turnstileLanguage = () =>
  LANG_MAP[localStorage.getItem('language') || 'en'] || 'auto';

let scriptPromise;
const loadScript = () => {
  if (window.turnstile) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = SCRIPT_URL;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve();
    s.onerror = () => {
      scriptPromise = undefined;
      reject(new Error('turnstile script load failed'));
    };
    document.head.appendChild(s);
  });
  return scriptPromise;
};

// Cloudflare Turnstile 挂件:验证通过后把一次性 token 交给 onToken。
// 未配置 REACT_APP_TURNSTILE_SITEKEY 时不渲染(父组件回退到滑块验证)。
// token 是一次性的,注册失败后父组件通过改 key 重挂本组件即可重新验证。
const TurnstileWidget = ({ onToken, theme = 'auto' }) => {
  const holderRef = useRef(null);
  const widgetIdRef = useRef(null);
  const onTokenRef = useRef(onToken);
  onTokenRef.current = onToken;
  const themeRef = useRef(theme);
  themeRef.current = theme;

  useEffect(() => {
    if (!SITEKEY) return undefined;
    let cancelled = false;
    loadScript()
      .then(() => {
        if (cancelled || !holderRef.current || !window.turnstile) return;
        widgetIdRef.current = window.turnstile.render(holderRef.current, {
          sitekey: SITEKEY,
          language: turnstileLanguage(),
          theme: themeRef.current,
          callback: (token) => onTokenRef.current(token),
          'expired-callback': () => onTokenRef.current(null),
          'error-callback': () => onTokenRef.current(null)
        });
      })
      .catch(() => onTokenRef.current(null));
    return () => {
      cancelled = true;
      if (widgetIdRef.current != null && window.turnstile) {
        try { window.turnstile.remove(widgetIdRef.current); } catch (e) { /* already removed */ }
        widgetIdRef.current = null;
      }
    };
  }, []);

  if (!SITEKEY) return null;
  // 悬浮在视口底部居中,不占表单版面
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[70]">
      <div ref={holderRef} className="min-h-[65px]" />
    </div>
  );
};

export default TurnstileWidget;
